// 업체 번호 두 개(사장님 휴대폰·보호자 문의 번호) 형식 검사 — 서버 createOrg.ts의 MOBILE·CONTACT와 같은 규칙
export const digitsOnly = (s: string) => String(s || "").replace(/[^0-9]/g, "");

/** 사장님 휴대폰 — 청구 문자를 받아야 하므로 휴대폰만 */
export const isOwnerPhone = (s: string) => /^01[016789]\d{7,8}$/.test(digitsOnly(s));

/** 보호자 문의 번호 — 휴대폰·사무실 번호(02·051·070 등)·대표번호(1588 등) */
export const isGuardianContactPhone = (s: string) => /^(0\d{8,10}|1[5-9]\d{6})$/.test(digitsOnly(s));
